/**
 * DODO DEER Easify cart bridge v4
 * Product pages only — draft theme Dododeer2
 */
(function () {
  'use strict';

  var VERSION = '13.0.0';
  var PENDING_KEY = '__dodoEasifyCartData';
  var FEE_KEY = 'Engraving Surcharge';
  var BLOCK_KEY = '__dodoBlockEasifyCartAdd';
  var BUSY_KEY = '__dodoEasifyAddBusy';

  if (window.console && window.console.log) {
    window.console.log('[dodo-easify] bridge v' + VERSION);
  }

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function visibleModal() {
    var nodes = qsa(
      'dialog.tpo_edit-option-modal[open], .tpo_edit-option-modal, .tpo_modal-container, ' +
      '.tpo_modal-background, #product_custom_engraving.in, #product_custom_engraving.show, #product_custom_engraving'
    );
    var best = null;
    var bestArea = 0;
    nodes.forEach(function (el) {
      if (el.tagName === 'DIALOG' && 'open' in el && !el.open) return;
      var style = window.getComputedStyle(el);
      if (!style || style.display === 'none' || style.visibility === 'hidden') return;
      var r = el.getBoundingClientRect();
      var area = r.width * r.height;
      if (r.width > 80 && r.height > 80 && area > bestArea) {
        best = el;
        bestArea = area;
      }
    });
    return best;
  }

  function getDialog() {
    return qs('dialog.tpo_edit-option-modal[open]');
  }

  function getModal() {
    return visibleModal();
  }

  function isModalOpen() {
    return !!visibleModal();
  }

  function getRoot() {
    return visibleModal();
  }

  function getForm() {
    return document.getElementById('add-to-cart-form');
  }

  function hasEasify() {
    return !!qs('.easify-product-options');
  }

  function variantId(form) {
    if (!form) return null;
    var el = form.querySelector('[name="id"]');
    if (el && el.value) return String(el.value);
    el = form.querySelector('#product-selectors');
    return el && el.value ? String(el.value) : null;
  }

  function quantity(form) {
    var el = form && form.querySelector('[name="quantity"]');
    var n = el ? parseInt(el.value, 10) : 1;
    return n > 0 ? n : 1;
  }

  function money(text) {
    var m = String(text || '').match(/(\d[\d.,]*)/);
    if (!m) return 0;
    var n = parseFloat(m[1].replace(/,/g, ''));
    return isNaN(n) ? 0 : n;
  }

  function priceFrom(text) {
    var m = String(text || '').match(/\(\$?\s*([\d.,]+)\s*\)/);
    return m ? money(m[1]) : 0;
  }

  function clean(text) {
    return String(text || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function isJunkText(text) {
    var t = String(text || '').trim();
    if (!t) return true;
    if (/[{}]/.test(t) && /display\s*:|selector|wrapper|add-to-cart|#add/i.test(t)) return true;
    if (/#add[\s-]*to[\s-]*cart/i.test(t)) return true;
    if (/display\s*:\s*none/i.test(t)) return true;
    return false;
  }

  function isVariantNoiseKey(key) {
    var k = String(key || '').trim();
    if (/^(quantity|qty|color|colour|size|id|variant)$/i.test(k)) return true;
    if (/^color\s*[a-z0-9]*(\s+\d+)?$/i.test(k)) return true;
    return false;
  }

  function isGarbageValue(val) {
    var t = String(val || '').trim();
    if (isJunkText(t)) return true;
    if (/no results found/i.test(t)) return true;
    if (/design it yourself/i.test(t) && /same design as/i.test(t)) return true;
    if ((t.match(/\bfor\s+(Dad|Mom|Son|Daughter|Husband|Wife|Love|Wedding)/gi) || []).length >= 2) return true;
    return false;
  }

  function isGarbageKey(key) {
    var k = String(key || '').trim();
    if (isVariantNoiseKey(k)) return true;
    if (/^for\s+/i.test(k)) return true;
    if (/no results found/i.test(k)) return true;
    return false;
  }

  function isPlaceholderValue(val) {
    var v = String(val || '').trim();
    if (!v || /^yes$/i.test(v) || v === 'on' || v === 'true' || v === '1') return true;
    if (/\[\s*\+?\s*\$/.test(v)) return true;
    if (/^(dial engraving|caseback engraving|buckle engraving|box engraving)(\s*\[.*\])?$/i.test(v)) return true;
    return false;
  }

  function designCode(text) {
    var m = String(text || '').match(/Design\s*0*\d+/i);
    return m ? m[0].replace(/\s+/g, ' ').trim() : '';
  }

  function labelKey(raw) {
    var k = String(raw || '').replace(/^_/, '').replace(/[_-]+/g, ' ').replace(/\s+/g, ' ').trim();
    k = k.replace(/[\*★]+/g, '').trim();
    if (isJunkText(k) || isVariantNoiseKey(k)) return '';
    if (/^design$/i.test(k) || /^design\s*\*+$/i.test(k) || /文案图片|设计图/.test(k)) return 'Design';
    if (/edit it yourself/i.test(k) || /给谁|礼物|下[来拉]框|recipient/i.test(k)) return 'Recipient';
    if (/定制文字/.test(k)) return 'Caseback Engraving';
    if (/表盘定制|dial custom/i.test(k)) return 'Dial Engraving';
    if (/dial/i.test(k) && /engr|custom/i.test(k)) return 'Dial Engraving';
    if (/caseback/i.test(k)) return 'Caseback Engraving';
    if (/buckle/i.test(k)) return 'Buckle Engraving';
    if (/box/i.test(k) && /engr/i.test(k)) return 'Box Engraving';
    return k;
  }

  function isInternalKey(key) {
    return /^_tpo_/i.test(key) && !/^_tpo_price$/i.test(key);
  }

  function isSkippableValue(val) {
    var v = String(val || '').trim().toLowerCase();
    return !v || v === 'false' || v === 'null' || v === 'undefined';
  }

  function isUiVisible(el) {
    if (!el || el.nodeType !== 1) return false;
    if (el.disabled) return false;
    if (el.type === 'hidden') return false;
    if (el.classList && (el.classList.contains('tpo_hidden') || el.classList.contains('tpo_hidden-checkbox'))) {
      return el.checked === true;
    }
    var node = el;
    while (node && node !== document.body) {
      var style = window.getComputedStyle(node);
      if (!style || style.display === 'none' || style.visibility === 'hidden') return false;
      node = node.parentElement;
    }
    var r = el.getBoundingClientRect();
    if (r.width < 1 || r.height < 1) return false;
    return true;
  }

  function nearbyLabel(el) {
    var node = el;
    var depth = 0;
    while (node && node !== document.body && depth < 12) {
      var head = null;
      if (node.children) {
        Array.prototype.forEach.call(node.children, function (child) {
          if (head) return;
          if (/option-name|option-title/i.test(child.className || '') || /^(H3|H4|H5)$/.test(child.tagName)) {
            head = child;
          }
        });
      }
      if (head) {
        var ht = normalizeHeading(head.textContent || head.getAttribute('aria-label') || '');
        if (ht) return ht;
      }

      var prev = node.previousElementSibling;
      while (prev) {
        var clone = prev.cloneNode(true);
        qsa('style, script, input, textarea, select, button, img, svg, [class*="swatch"]', clone)
          .forEach(function (n) { if (n.parentNode) n.parentNode.removeChild(n); });
        var pt = normalizeHeading(clone.textContent || '');
        if (pt) return pt;
        prev = prev.previousElementSibling;
      }

      var blob = String(node.textContent || '').slice(0, 220);
      if (/buckle/i.test(blob)) return 'Buckle Engraving';
      if (/box/i.test(blob) && /engr|design/i.test(blob)) return 'Box Engraving';
      if (/caseback|back cover/i.test(blob)) return 'Caseback Engraving';
      if (/\bdial\b/i.test(blob) && /engr|custom/i.test(blob)) return 'Dial Engraving';
      if (/^\s*design\b/i.test(clean(blob).slice(0, 24))) return 'Design';

      node = node.parentElement;
      depth += 1;
    }
    return '';
  }

  function normalizeHeading(text) {
    var t = clean(text).replace(/[\*★]+/g, ' ').replace(/\(.*?\)/g, ' ').replace(/[:：]+$/g, '');
    t = clean(t);
    if (!t || isJunkText(t)) return '';
    if (/max\s*\d+\s*character/i.test(t)) return '';
    if (/^design\b/i.test(t) && t.length < 24) return 'Design';
    if (/buckle/i.test(t)) return 'Buckle Engraving';
    if (/box/i.test(t) && /engr|design/i.test(t)) return 'Box Engraving';
    if (/caseback|back cover/i.test(t)) return 'Caseback Engraving';
    if (/dial/i.test(t) && /engr|custom/i.test(t)) return 'Dial Engraving';
    if (t.length > 48) return '';
    return labelKey(t) || t;
  }

  function headingFrom(wrap) {
    if (!wrap) return '';
    var el = wrap.querySelector(
      '.tpo_option-name, .tpo_option-title, .tpo_option-label, [class*="option-name"], ' +
      '[class*="option-title"], [class*="option-label"], legend, h3, h4, h5'
    );
    var text = '';
    if (el) {
      text = clean(el.getAttribute('aria-label') || el.textContent);
    }
    if (!text || isJunkText(text)) {
      var clone = wrap.cloneNode(true);
      qsa('style, script, noscript, input, textarea, select, button, img, svg, .tpo_additional-price, [class*="price"], [class*="swatch"]', clone)
        .forEach(function (node) { if (node.parentNode) node.parentNode.removeChild(node); });
      text = clean(clone.textContent);
    }
    text = text.replace(/\(.*?\)/g, ' ').replace(/\+\s*\$?\s*[\d.,]+/g, ' ');
    text = clean(text).replace(/[:：]+$/, '').replace(/[\*★]+/g, '').trim();
    if (isJunkText(text)) return '';
    if (/^design\b/i.test(text)) return 'Design';
    if (text.length > 60) text = text.slice(0, 60).trim();
    return text;
  }

  function selectedControlValue(el) {
    if (!el) return '';
    if (el.tagName === 'SELECT') {
      if (el.selectedIndex < 0) return '';
      var opt = el.options[el.selectedIndex];
      var selectVal = clean((opt && (opt.text || opt.value)) || el.value);
      return isJunkText(selectVal) ? '' : selectVal;
    }
    if (el.type === 'checkbox' || el.getAttribute('role') === 'checkbox') {
      var checked = el.checked || el.getAttribute('aria-checked') === 'true';
      if (!checked) return '';
      var raw = String(el.value || '').trim();
      if (!raw || raw === 'on' || raw === 'true' || raw === '1') return 'Yes';
      return isJunkText(raw) ? 'Yes' : clean(raw);
    }
    if (el.type === 'radio') {
      if (!el.checked) return '';
      var radioVal = clean(el.value || el.getAttribute('aria-label') || '');
      return isJunkText(radioVal) ? '' : radioVal;
    }
    var inputVal = clean(el.value || '');
    return isJunkText(inputVal) ? '' : inputVal;
  }

  function designLabelFrom(el) {
    if (!el) return '';
    var parts = [];
    var nodes = [el, el.parentElement, el.previousElementSibling];
    nodes.forEach(function (node) {
      if (!node || node.nodeType !== 1) return;
      parts.push(
        node.getAttribute('title'),
        node.getAttribute('aria-label'),
        node.getAttribute('data-value'),
        node.getAttribute('data-label'),
        node.getAttribute('data-title'),
        node.getAttribute('data-option-value'),
        node.getAttribute('data-name')
      );
      qsa('[class*="tooltip"], [class*="swatch-label"], [class*="swatch-name"], [class*="value-label"], [class*="option-value"], [class*="value-name"]', node)
        .forEach(function (lab) {
          parts.push(lab.getAttribute('title'), lab.getAttribute('aria-label'), lab.textContent);
        });
      var img = node.querySelector && node.querySelector('img');
      if (img) parts.push(img.getAttribute('alt'), img.getAttribute('title'));
    });

    var i;
    for (i = 0; i < parts.length; i++) {
      var code = designCode(parts[i]);
      if (code) return code;
    }
    return '';
  }

  function swatchValue(el) {
    return designLabelFrom(el);
  }

  function isSelectedSwatch(el) {
    if (!el) return false;
    var node = el;
    var hops = 0;
    while (node && hops < 3) {
      if (node.getAttribute && (
        node.getAttribute('aria-pressed') === 'true' ||
        node.getAttribute('aria-checked') === 'true' ||
        node.getAttribute('aria-selected') === 'true'
      )) {
        return true;
      }
      if (node.classList && (
        node.classList.contains('selected') ||
        node.classList.contains('active') ||
        node.classList.contains('is-selected') ||
        node.classList.contains('tpo_selected')
      )) {
        return true;
      }
      var input = node.matches && node.matches('input') ? node : node.querySelector && node.querySelector(':scope > input[type="radio"]:checked, :scope > input[type="checkbox"]:checked');
      if (input && input.checked) return true;
      node = node.parentElement;
      hops += 1;
    }
    try {
      var cs = window.getComputedStyle(el);
      var bw = parseFloat(cs.borderTopWidth) || 0;
      if (bw >= 2 && /rgb\(\s*0,\s*0,\s*0|rgb\(\s*15,\s*15,\s*15|#000|#111|#0f0f0f/i.test(cs.borderTopColor || '')) {
        return true;
      }
    } catch (e) {}
    return false;
  }

  function setProp(properties, key, value) {
    value = String(value || '').trim().slice(0, 200);
    if (isSkippableValue(value) || isJunkText(value) || isGarbageValue(value) || isPlaceholderValue(value)) return;

    if (/^for\s+/i.test(value)) key = 'Recipient';
    else if (designCode(value) && (/design/i.test(String(key)) || /文案图片|设计图/.test(String(key)) || !key)) {
      key = 'Design';
      value = designCode(value);
    }

    var mapped = labelKey(key) || normalizeHeading(key);
    if (!mapped) {
      if (/^for\s+/i.test(value)) mapped = 'Recipient';
      else if (designCode(value)) mapped = 'Design';
      else return;
    }
    if (isInternalKey(mapped) || isGarbageKey(mapped)) return;
    if (/^for\s+/i.test(value)) mapped = 'Recipient';
    if (designCode(value) && (/^design$/i.test(mapped) || /文案图片|设计图/.test(String(key)))) {
      mapped = 'Design';
      value = designCode(value);
    }
    key = mapped;
    if (key === FEE_KEY) {
      properties[key] = value;
      return;
    }
    if (/^design$/i.test(key)) {
      var code = designCode(value);
      if (!code) return;
      value = code;
    }
    if (!properties[key] || isPlaceholderValue(properties[key])) {
      properties[key] = value;
    }
  }

  function collectNamedProperties(scope, properties) {
    if (!scope) return;
    qsa('input[name^="properties["], textarea[name^="properties["], select[name^="properties["]', scope).forEach(function (input) {
      var m = String(input.name || '').match(/^properties\[([^\]]+)\]$/);
      if (!m) return;
      var key = m[1];
      if (isInternalKey(key) || isGarbageKey(key)) return;
      if ((input.type === 'checkbox' || input.type === 'radio') && !input.checked) return;
      var val = selectedControlValue(input);
      if (!val) val = String(input.value || '').trim();
      if (input.type === 'checkbox' || input.type === 'radio') {
        if (isPlaceholderValue(val)) return;
      }
      if (isGarbageValue(val) || isPlaceholderValue(val)) return;
      setProp(properties, key, val);
    });
  }

  function scrapeOptionBlock(wrap, properties) {
    if (!wrap || !isUiVisible(wrap)) return;
    var name = headingFrom(wrap);

    if (/^design$/i.test(name)) {
      var selected = null;
      qsa('[class*="tpo_swatch"], [class*="image-swatch"], [class*="swatch-item"], [data-swatch], button, [role="radio"]', wrap).forEach(function (el) {
        if (isSelectedSwatch(el)) selected = el;
      });
      var code = selected ? (designLabelFrom(selected) || designLabelFrom(selected.parentElement)) : '';
      if (!code) {
        qsa('[class*="tooltip"], [class*="swatch-label"], [class*="swatch-name"], [class*="value-label"]', wrap).forEach(function (lab) {
          if (code || !isUiVisible(lab)) return;
          code = designCode(lab.textContent || lab.getAttribute('title') || '');
        });
      }
      if (code) setProp(properties, 'Design', code);
    }

    qsa('input[type="text"], textarea', wrap).forEach(function (input) {
      if (!isUiVisible(input)) return;
      var val = String(input.value || '').trim();
      if (!val) return;
      var key = headingFrom(optionWrap(input) || wrap) || input.getAttribute('placeholder') || name || 'Engraving';
      setProp(properties, key, val);
    });

    qsa('select', wrap).forEach(function (sel) {
      if (!isUiVisible(sel)) return;
      var val = selectedControlValue(sel);
      if (!val) return;
      var key = headingFrom(optionWrap(sel) || wrap) || name || 'Option';
      setProp(properties, key, val);
    });

    qsa(
      '[class*="dropdown"] [class*="selected"], [class*="tpo_select"] [class*="selected"], ' +
      '[class*="tpo_dropdown-selected"], [class*="selected-value"], [class*="select-value"]',
      wrap
    ).forEach(function (el) {
      if (!isUiVisible(el)) return;
      var val = clean(el.textContent);
      if (!val || /select|choose|option/i.test(val)) return;
      var key = headingFrom(optionWrap(el) || wrap) || name || 'Option';
      setProp(properties, key, val);
    });

    qsa(
      'input.tpo-checkbox-button, input.tpo_checkbox-button, input.tpo_radio-button, ' +
      'input[type="checkbox"], input[type="radio"], [role="checkbox"]',
      wrap
    ).forEach(function (input) {
      if (input.closest && input.closest('.swatch, .swatch-element, [class*="color-swatch"]')) return;
      if (input.name === 'quantity' || input.name === 'id') return;
      var checked = input.checked || input.getAttribute('aria-checked') === 'true';
      if (!checked) return;
      var key = headingFrom(optionWrap(input) || wrap) || name;
      if (/^design$/i.test(key)) return;
      var val = selectedControlValue(input);
      var textInput = (optionWrap(input) || wrap).querySelector('input[type="text"], textarea');
      if (textInput && String(textInput.value || '').trim()) {
        val = String(textInput.value).trim();
      }
      setProp(properties, key || 'Engraving', val || 'Yes');
    });

    qsa(
      '[class*="tpo_swatch"], [class*="image-swatch"], [data-swatch], [class*="swatch-item"]',
      wrap
    ).forEach(function (el) {
      if (el.closest && el.closest('.product-shop .swatch, .selector-wrapper, #add-to-cart-form .swatch')) return;
      if (!isSelectedSwatch(el)) return;
      var val = designLabelFrom(el) || designLabelFrom(el.parentElement);
      if (!val) return;
      setProp(properties, 'Design', val);
    });
  }

  function scrapeFromUi(root, properties) {
    if (!root) return;
    var wraps = qsa(
      '.tpo_option-container, [class*="tpo_option-container"], [class*="tpo_option_container"], ' +
      '.container-wrap-selection, [class*="easify-option-"], [data-option-id], [data-easify-option-id]',
      root
    );

    if (!wraps.length) {
      var body = qs('.tpo_modal-body, .tpo_modal-content, .tpo_edit-option-content, .tpo_modal-container', root) || root;
      wraps = Array.prototype.filter.call(body.children || [], function (el) {
        return el.nodeType === 1 && el.querySelector && el.querySelector('input, select, textarea, [role="checkbox"], [role="radio"], [class*="swatch"]');
      });
    }

    wraps.forEach(function (wrap) {
      scrapeOptionBlock(wrap, properties);
    });

    qsa('input[type="text"], textarea', root).forEach(function (input) {
      if (input.name === 'quantity' || input.name === 'q') return;
      if (!isUiVisible(input)) return;
      var val = String(input.value || '').trim();
      if (!val) return;
      var wrap = optionWrap(input);
      var key = headingFrom(wrap) || input.getAttribute('placeholder') || input.getAttribute('aria-label') || 'Engraving';
      setProp(properties, key, val);
    });
  }

  function readFee(root) {
    var el = qs('.tpo_total-additional-price', root);
    if (el && money(el.textContent) > 0) return money(el.textContent);
    var sum = 0;
    qsa('.tpo_additional-price.active, .tpo_additional-price:not(.tpo_hidden)', root).forEach(function (node) {
      if (!isUiVisible(node)) return;
      var v = money(node.textContent);
      if (v > 0) sum += v;
    });
    return sum;
  }

  function ownText(el) {
    var t = '';
    Array.prototype.forEach.call(el.childNodes || [], function (n) {
      if (n.nodeType === 3) t += n.nodeValue || '';
    });
    return clean(t);
  }

  function optionWrap(el) {
    if (!el || !el.closest) return null;
    return el.closest(
      '.tpo_option-container, [class*="tpo_option-container"], [class*="tpo_option_container"], ' +
      '[data-option-id], [data-easify-option-id], .container-wrap-selection, fieldset'
    );
  }

  function optionHeading(wrap) {
    if (!wrap) return '';
    var el = wrap.querySelector(
      '.tpo_option-name, .tpo_option-title, .tpo_option-label, [class*="option-name"], ' +
      '[class*="option-title"], [class*="option-label"], legend, h3, h4, h5'
    );
    if (!el) return '';
    var text = clean(el.getAttribute('aria-label') || ownText(el) || el.textContent);
    text = text.replace(/[\*★]+/g, ' ').replace(/\(.*?\)/g, ' ').replace(/[:：]+$/g, '');
    text = clean(text);
    if (!text || isJunkText(text) || isGarbageKey(text) || text.length > 48) return '';
    return labelKey(text) || text;
  }

  function dropdownSelectedValue(wrap) {
    if (!wrap) return '';
    var found = '';
    var sels = [
      '[class*="dropdown-selected"]',
      '[class*="selected-value"]',
      '[class*="select-value"]',
      '[class*="tpo_select"] > [class*="selected"]',
      '[class*="tpo_dropdown"] > [class*="selected"]',
      '[aria-haspopup="listbox"]',
      '[class*="dropdown-toggle"]'
    ];
    sels.forEach(function (sel) {
      if (found) return;
      qsa(sel, wrap).forEach(function (el) {
        if (found || !isUiVisible(el)) return;
        var val = ownText(el) || clean(el.textContent);
        if (!val || val.length > 80 || isGarbageValue(val)) return;
        if (/^(select|choose|please select)/i.test(val)) return;
        found = val;
      });
    });
    return found;
  }

  function sectionIdFromText(text) {
    var t = String(text || '');
    if (/dial/i.test(t) && /engr/i.test(t)) return 'dial';
    if (/caseback/i.test(t)) return 'caseback';
    if (/buckle/i.test(t)) return 'buckle';
    if (/\bbox\b/i.test(t) && /engr/i.test(t)) return 'box';
    return '';
  }

  function sectionIdFromKey(key) {
    var mapped = labelKey(key) || key;
    if (/^dial engraving$/i.test(mapped) || /^dial customization$/i.test(mapped)) return 'dial';
    if (/^caseback engraving$/i.test(mapped) || /^recipient$/i.test(mapped) || /^design$/i.test(mapped)) return 'caseback';
    if (/^buckle engraving$/i.test(mapped)) return 'buckle';
    if (/^box engraving$/i.test(mapped)) return 'box';
    return '';
  }

  function isSectionToggle(input) {
    if (!input) return false;
    if (input.closest && input.closest('[class*="swatch"], [class*="dropdown"]')) return false;
    return true;
  }

  function checkboxSectionId(input) {
    if (!isSectionToggle(input)) return '';
    var lab = input.closest('label');
    if (lab) {
      var id = sectionIdFromText(clean(lab.textContent).slice(0, 100));
      if (id) return id;
    }
    if (input.id) {
      var forLab = document.querySelector('label[for="' + input.id.replace(/"/g, '') + '"]');
      if (forLab) {
        var id2 = sectionIdFromText(clean(forLab.textContent).slice(0, 100));
        if (id2) return id2;
      }
    }
    var wrap = optionWrap(input) || input.parentElement;
    var wrapHeading = optionHeading(wrap);
    if (/^design$/i.test(wrapHeading)) return '';
    var hops = 0;
    var node = input;
    while (node && hops < 6) {
      var head = node.querySelector && node.querySelector(
        '.tpo_option-name, .tpo_option-title, [class*="option-name"], [class*="option-title"]'
      );
      if (head) {
        var id3 = sectionIdFromText(head.textContent);
        if (id3) return id3;
      }
      var prev = node.previousElementSibling;
      if (prev) {
        var id4 = sectionIdFromText(clean(prev.textContent).slice(0, 80));
        if (id4) return id4;
      }
      node = node.parentElement;
      hops += 1;
    }
    return sectionIdFromText(input.value) || sectionIdFromText(input.getAttribute('aria-label') || '');
  }

  function activeSections(root) {
    var on = { dial: false, caseback: false, buckle: false, box: false, gated: false };
    if (!root) return on;
    qsa('input[type="checkbox"], [role="checkbox"]', root).forEach(function (input) {
      var id = checkboxSectionId(input);
      if (!id) return;
      on.gated = true;
      if (input.checked || input.getAttribute('aria-checked') === 'true') on[id] = true;
    });
    return on;
  }

  function applySectionGate(properties, active) {
    if (!active || !active.gated) return;
    if (!active.caseback) {
      delete properties.Design;
      delete properties.Recipient;
      delete properties['Caseback Engraving'];
    }
    if (!active.dial) {
      delete properties['Dial Engraving'];
      delete properties['Dial Customization'];
    }
    if (!active.buckle) delete properties['Buckle Engraving'];
    if (!active.box) delete properties['Box Engraving'];
  }

  function scrapeDesignNumber(root, properties) {
    if (!root) return;
    var code = '';

    function consider(text, preferred) {
      var c = designCode(text);
      if (!c) return;
      if (preferred || !code) code = c;
    }

    qsa('img, button, [class*="swatch"], [role="radio"], [class*="option-value"]', root).forEach(function (el) {
      if (!isUiVisible(el)) return;
      if (!isSelectedSwatch(el) && !isSelectedSwatch(el.parentElement)) return;
      consider(designLabelFrom(el) || designLabelFrom(el.parentElement), true);
      var item = el.closest('button, label, li, [class*="swatch"], [role="radio"]') || el;
      var scope = item.parentElement || item;
      qsa('[class*="tooltip"], [class*="swatch-label"], [class*="caption"], [class*="value-label"], [class*="swatch-name"]', scope)
        .forEach(function (lab) {
          if (!isUiVisible(lab)) return;
          consider(ownText(lab) || lab.getAttribute('title') || lab.textContent, true);
        });
    });

    if (!code) {
      qsa('span, div, p, figcaption, label, strong, small, em', root).forEach(function (el) {
        if (!isUiVisible(el)) return;
        var own = ownText(el);
        if (/^design\s*\d+$/i.test(own)) consider(own, true);
      });
    }

    if (code) properties.Design = code;
  }

  function scrapeSelections(root, properties, active) {
    if (!root) return;
    var wraps = qsa(
      '.tpo_option-container, [class*="tpo_option-container"], [class*="tpo_option_container"], ' +
      '[data-option-id], [data-easify-option-id], .container-wrap-selection',
      root
    );

    wraps.forEach(function (wrap) {
      if (!isUiVisible(wrap)) return;
      var key = optionHeading(wrap);
      var sid = sectionIdFromKey(key) || sectionIdFromText(key);
      if (active && active.gated && sid && !active[sid]) return;

      qsa('input[type="text"], textarea', wrap).forEach(function (input) {
        if (!isUiVisible(input) || input.name === 'quantity' || input.name === 'q' || input.name === 'id') return;
        var val = String(input.value || '').trim();
        if (!val || isGarbageValue(val) || isPlaceholderValue(val)) return;
        if (/^for\s+/i.test(val)) {
          setProp(properties, 'Recipient', val);
          return;
        }
        var k = key;
        if (!k || isGarbageKey(k) || /^design$/i.test(k) || /max\s*\d+\s*character/i.test(k)) {
          k = '';
        }
        if (!k) return;
        setProp(properties, k, val);
      });

      qsa('select', wrap).forEach(function (sel) {
        if (!isUiVisible(sel)) return;
        var val = selectedControlValue(sel);
        if (!val || isGarbageValue(val) || isPlaceholderValue(val)) return;
        if (/^for\s+/i.test(val)) {
          setProp(properties, 'Recipient', val);
          return;
        }
        if (!key || isGarbageKey(key) || /^design$/i.test(key)) return;
        setProp(properties, key, val);
      });

      var drop = dropdownSelectedValue(wrap);
      if (drop) {
        if (/^for\s+/i.test(drop)) setProp(properties, 'Recipient', drop);
        else if (key && !isGarbageKey(key) && !/^design$/i.test(key)) setProp(properties, key, drop);
      }
    });
  }

  function compactProperties(properties) {
    if (properties['Dial Customization']) {
      if (!properties['Dial Engraving'] || isPlaceholderValue(properties['Dial Engraving'])) {
        properties['Dial Engraving'] = properties['Dial Customization'];
      }
      delete properties['Dial Customization'];
    }
    if (properties.Engraving) {
      var extra = properties.Engraving;
      if (/^for\s+/i.test(extra) && !properties.Recipient) properties.Recipient = extra;
      delete properties.Engraving;
    }
    Object.keys(properties).forEach(function (key) {
      if (key === FEE_KEY) return;
      if (/\s+\d+$/.test(key) || isGarbageKey(key) || isPlaceholderValue(properties[key]) || isGarbageValue(properties[key])) {
        delete properties[key];
      }
    });
    var byValue = {};
    var prefer = {
      'dial engraving': 10,
      'caseback engraving': 10,
      'buckle engraving': 10,
      recipient: 10,
      design: 10
    };
    Object.keys(properties).forEach(function (key) {
      if (key === FEE_KEY) return;
      var nv = String(properties[key]).toLowerCase();
      if (byValue[nv]) {
        var prev = byValue[nv];
        var prevScore = prefer[prev.toLowerCase()] || 0;
        var curScore = prefer[key.toLowerCase()] || 0;
        if (curScore > prevScore) {
          delete properties[prev];
          byValue[nv] = key;
        } else {
          delete properties[key];
        }
      } else {
        byValue[nv] = key;
      }
    });
  }

  function scrapeUnsafe() {
    var root = visibleModal();
    var form = getForm();
    var properties = {};
    var fee = readFee(root);
    var active = activeSections(root);

    collectNamedProperties(root, properties);
    collectNamedProperties(form, properties);
    scrapeSelections(root, properties, active);
    if (active.caseback) scrapeDesignNumber(root, properties);
    compactProperties(properties);
    applySectionGate(properties, active);

    Object.keys(properties).forEach(function (key) {
      if (isInternalKey(key) || key === FEE_KEY) return;
      if (isSkippableValue(properties[key]) || isGarbageValue(properties[key]) || isGarbageKey(key) || isPlaceholderValue(properties[key])) {
        delete properties[key];
      }
      var sid = sectionIdFromKey(key);
      if (active.gated && sid && !active[sid]) delete properties[key];
    });

    var keys = Object.keys(properties).filter(function (key) {
      return key !== FEE_KEY;
    });
    if (!keys.length) {
      return { properties: {}, extraFee: 0, hasCustomization: false };
    }
    if (fee <= 0) fee = 10;
    properties[FEE_KEY] = String(fee);
    return { properties: properties, extraFee: fee, hasCustomization: true };
  }

  function scrape() {
    try {
      return scrapeUnsafe();
    } catch (e) {
      if (window.console && window.console.warn) {
        window.console.warn('[dodo-easify] scrape failed', e);
      }
      return { properties: {}, extraFee: 0, hasCustomization: false };
    }
  }

  function savePending(state, vid) {
    if (!state || !state.hasCustomization) return;
    window[PENDING_KEY] = {
      properties: state.properties,
      extraFee: state.extraFee || money(state.properties[FEE_KEY]),
      hasCustomization: true,
      variantId: vid || null
    };
  }

  function getState(vid) {
    if (window[PENDING_KEY] && window[PENDING_KEY].hasCustomization) {
      return window[PENDING_KEY];
    }
    var live = scrape();
    if (live.hasCustomization) savePending(live, vid);
    return live;
  }

  function nativeFetch(url, init) {
    return (window.__dodoNativeFetch || window.fetch).call(window, url, init || {});
  }

  function postForm(url, params) {
    return nativeFetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded', Accept: 'application/json' },
      body: params.toString()
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error((data && data.description) || 'Request failed');
        return data;
      });
    });
  }

  function postJson(url, body) {
    return nativeFetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error((data && data.description) || 'Request failed');
        return data;
      });
    });
  }

  function getCart() {
    return nativeFetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function lineKey(cart, vid) {
    if (!cart || !cart.items) return null;
    var id = parseInt(vid, 10);
    for (var i = cart.items.length - 1; i >= 0; i--) {
      if (cart.items[i].variant_id === id) return cart.items[i].key;
    }
    return cart.items.length ? cart.items[cart.items.length - 1].key : null;
  }

  function addProps(key, qty, props) {
    if (!key || !props || !Object.keys(props).length) return Promise.resolve();
    return postJson('/cart/change.js', { id: key, quantity: qty, properties: props }).catch(function () {
      var copy = {};
      Object.keys(props).forEach(function (k) { if (k !== FEE_KEY) copy[k] = props[k]; });
      if (Object.keys(copy).length) {
        return postJson('/cart/change.js', { id: key, quantity: qty, properties: copy });
      }
    });
  }

  function forcePaint(props, baseCents) {
    if (!props || !Object.keys(props).length) return;
    if (window.luxwatches && window.luxwatches.forceEasifyCartDisplay) {
      window.luxwatches.forceEasifyCartDisplay(props, baseCents);
    }
  }

  function openDrawer(props, vid, baseCents) {
    savePending({ properties: props, extraFee: money(props[FEE_KEY]), hasCustomization: true }, vid);
    if (window.luxwatches && window.luxwatches.openCartDrawerAfterAdd) {
      window.luxwatches.openCartDrawerAfterAdd();
    }
    [200, 600, 1200, 2000, 3500].forEach(function (ms) {
      setTimeout(function () {
        forcePaint(props, baseCents);
        if (window.luxwatches && window.luxwatches.adjustCartDrawerTpoPrices) {
          window.luxwatches.adjustCartDrawerTpoPrices();
        }
      }, ms);
    });
    setTimeout(function () { window[PENDING_KEY] = null; }, 15000);
  }

  function addToCart(vid, qty, props) {
    window[BUSY_KEY] = true;
    window.easifyAddToCartEvent = true;
    window[BLOCK_KEY] = true;
    setTimeout(function () { window[BLOCK_KEY] = false; }, 6000);

    if (window.luxwatches && window.luxwatches.showLoading) window.luxwatches.showLoading();

    props = props || {};
    var fee = money(props[FEE_KEY]);
    var baseCents = null;

    function finish() {
      window[BUSY_KEY] = false;
      if (window.luxwatches && window.luxwatches.hideLoading) window.luxwatches.hideLoading();
    }

    var formBody = new URLSearchParams();
    formBody.append('id', vid);
    formBody.append('quantity', String(qty));
    Object.keys(props).forEach(function (k) {
      formBody.append('properties[' + k + ']', props[k]);
    });

    return postForm('/cart/add.js', formBody)
      .then(function () { return getCart(); })
      .then(function (cart) {
        var item = null;
        var key = lineKey(cart, vid);
        cart.items.forEach(function (it) {
          if (it.key === key) item = it;
        });
        if (item) baseCents = item.final_line_price;
        var needsProps = props && Object.keys(props).length;
        if (needsProps && key) {
          var has = item && item.properties && Object.keys(props).some(function (k) {
            return k !== FEE_KEY && item.properties[k] === props[k];
          });
          if (!has) return addProps(key, qty, props).then(function () { return getCart(); });
        }
        return cart;
      })
      .then(function () {
        openDrawer(props, vid, baseCents);
      })
      .catch(function () {
        return postJson('/cart/add.js', {
          items: [{ id: parseInt(vid, 10), quantity: qty, properties: props }]
        }).then(function () {
          openDrawer(props, vid, baseCents);
        });
      })
      .catch(function () {
        var bare = new URLSearchParams();
        bare.append('id', vid);
        bare.append('quantity', String(qty));
        return postForm('/cart/add.js', bare).then(function () {
          return getCart().then(function (cart) {
            baseCents = cart.items.length ? cart.items[cart.items.length - 1].final_line_price : null;
            return addProps(lineKey(cart, vid), qty, props);
          });
        }).then(function () {
          openDrawer(props, vid, baseCents);
        });
      })
      .then(finish, function (err) {
        finish();
        throw err;
      });
  }

  function closeModal() {
    var btn = qs('.tpo_close-popup-button, .tpo_modal-close-btn', getModal());
    if (btn) btn.click();
    var d = getDialog();
    if (d && d.open && d.close) d.close();
  }

  function isMainProductAddToCart(el) {
    if (!el || !el.closest) return false;
    var btn = el.closest('#product-add-to-cart, [data-btn-addToCart]');
    if (!btn) return false;
    return !btn.closest(
      '.tpo_modal-container, .tpo_modal-background, .tpo_edit-option-modal, ' +
      '#product_custom_engraving, dialog.tpo_edit-option-modal'
    );
  }

  function isEngravingTrigger(el) {
    if (!el || !el.closest) return false;
    var btn = el.closest('.tpo_open-modal-button, button[class*="tpo_open-modal"], [class*="tpo_open-modal"]');
    if (!btn) return false;
    return !btn.closest('.tpo_modal-container, .tpo_modal-background, .tpo_edit-option-modal, #product_custom_engraving');
  }

  function isBtn(el) {
    if (!el || !el.closest) return null;
    if (isMainProductAddToCart(el) || isEngravingTrigger(el)) return null;

    var hit = el.closest('.tpo_edit-option_confirm-button, .tpo_add-to-cart');
    if (hit && !isMainProductAddToCart(hit)) return hit;

    if (!isModalOpen()) return null;
    var b = el.closest('button, input[type="submit"], input[type="button"]');
    if (!b || isMainProductAddToCart(b) || isEngravingTrigger(b)) return null;
    var t = (b.textContent || b.value || '').toLowerCase();
    return t.indexOf('add to cart') >= 0 ? b : null;
  }

  function addMainProductAndOpenDrawer() {
    var form = getForm();
    var vid = variantId(form);
    if (!form || !vid) return;

    window[BUSY_KEY] = true;
    var params = new URLSearchParams();
    params.append('id', vid);
    params.append('quantity', String(quantity(form)));

    postForm('/cart/add.js', params)
      .then(function () {
        if (window.luxwatches && window.luxwatches.openCartDrawerAfterAdd) {
          window.luxwatches.openCartDrawerAfterAdd();
        }
      })
      .catch(function () {
        if (window.luxwatches && window.luxwatches.doAjaxAddToCartNormal && window.jQuery) {
          window.luxwatches.doAjaxAddToCartNormal(window.jQuery(form).serialize());
        }
      })
      .then(function () {
        setTimeout(function () { window[BUSY_KEY] = false; }, 1000);
      }, function () {
        window[BUSY_KEY] = false;
      });
  }

  function onClick(e) {
    if (!hasEasify()) return;

    if (isEngravingTrigger(e.target)) return;

    if (isMainProductAddToCart(e.target)) {
      if (e.type === 'pointerdown') return;
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      if (window[BUSY_KEY]) return false;
      addMainProductAndOpenDrawer();
      return false;
    }
    var btn = isBtn(e.target);
    if (!btn || btn.disabled) return;

    if (e.type === 'pointerdown') {
      savePending(scrape(), variantId(getForm()));
      return;
    }

    if (e.type !== 'click') return;

    if (window[BUSY_KEY]) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }

    var state = scrape();
    if (!state.hasCustomization && window[PENDING_KEY]) state = window[PENDING_KEY];
    if (!state.hasCustomization) {
      return;
    }

    var form = getForm();
    var vid = variantId(form);
    if (!form || !vid) {
      return;
    }

    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    var props = state.properties || {};
    closeModal();
    addToCart(vid, quantity(form), props).catch(function () {});
    return false;
  }

  if (!window.__dodoFetchGuard) {
    window.__dodoFetchGuard = true;
    window.__dodoNativeFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var method = ((init && init.method) || 'GET').toUpperCase();
      if (window[BLOCK_KEY] && method === 'POST' && url.indexOf('/cart/add.js') >= 0) {
        return Promise.resolve(new Response('{}', { status: 200, headers: { 'Content-Type': 'application/json' } }));
      }
      return window.__dodoNativeFetch.apply(window, arguments);
    };
  }

  document.addEventListener('pointerdown', onClick, true);
  document.addEventListener('pointerup', onClick, true);
  document.addEventListener('click', onClick, true);
  document.addEventListener('input', function () { if (isModalOpen()) savePending(scrape(), variantId(getForm())); }, true);
  document.addEventListener('change', function () { if (isModalOpen()) savePending(scrape(), variantId(getForm())); }, true);
  window.easifyAddToCartEvent = true;
})();
